/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

export default class TemplateRoute extends Route {
  // Services
  @service
  store;

  model(params) {
    return this.store.findRecord('people-schema/set', params.set_id);
  }
}
